import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import ProblemSolution from '../components/landing/ProblemSolution';
import HowItWorks from '../components/landing/HowItWorks';
import Benefits from '../components/landing/Benefits';
import VideoDemo from '../components/landing/VideoDemo';
import Pricing from '../components/landing/Pricing';
import FAQ from '../components/landing/FAQ';
import CTAFinal from '../components/landing/CTAFinal';
import Footer from '../components/landing/Footer';
import { initAnalytics, trackEvent } from '../lib/analytics';

export default function Landing() {
  const nav = useNavigate();

  useEffect(() => {
    initAnalytics();
  }, []);

  const irARegistro = (origen) => {
    trackEvent('landing_cta_click', { origen });
    nav('/login?tab=registro');
  };

  const verDemo = () => {
    trackEvent('landing_ver_demo_click');
    document.getElementById('como-funciona')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="landing-page font-sans text-slate-800">
      <Header onEmpezar={() => irARegistro('header')} />
      <Hero onEmpezar={() => irARegistro('hero')} onVerDemo={verDemo} />
      <ProblemSolution />
      <HowItWorks />
      <Benefits />
      <VideoDemo onVerDemo={verDemo} />
      <Pricing onSuscribirse={(tipo) => irARegistro(`pricing_${tipo}`)} />
      <FAQ />
      <CTAFinal onEmpezar={() => irARegistro('cta_final')} />
      <Footer />
    </div>
  );
}
